import { Axios } from '../axios';

const getDashboard = async () => {

  const { data } = await Axios.get('/dashboard');
  return data?.data;
};

export const dashboard = {
  getDashboard,
};
